import * as React from 'react'
import * as Styles from './itemview.module.sass'
import Slider from './slider'
import Button from './button'
import { Link } from 'gatsby'
import ReactVideo from './reactvideo'

const ImageSlide = ({ descr, main, alt, mat, playable }) => {
  return (
    <div className={`is-flex is-justify-content-center ${playable ? `${Styles.playable}` : ``}`} playable={playable}>
      {playable ? <>
        <ReactVideo innerclass={`${Styles.video}`} playsinline loop={true} muted={true} video={main.slvr} poster={alt.slvr} className={`${Styles.mainimage} ${Styles.innerslide} ${mat === 'slvr' ? `${Styles.slidetop}` : ``}`} alt={`Видео о продукции`} />
        <ReactVideo innerclass={`${Styles.video}`} playsinline loop={true} muted={true} video={main.brs} poster={alt.brs} className={`${Styles.mainimage} ${Styles.innerslide} ${mat === 'brs' ? `${Styles.slidetop}` : ``}`} alt={`Видео о продукции`} />
      </> : <>
        <picture>
          <source media="(max-width: 769px)" srcSet={alt.slvr} />
          <source media="(min-width: 770px)" srcSet={main.slvr} />
          <img className={`${Styles.mainimage} ${Styles.innerslide} ${mat === 'slvr' ? `${Styles.slidetop}` : ``}`} src={main.slvr} alt={`Изображение продукции`} />
        </picture>
        <picture>
          <source media="(max-width: 769px)" srcSet={alt.brs} />
          <source media="(min-width: 770px)" srcSet={main.brs} />
          <img className={`${Styles.mainimage} ${Styles.innerslide} ${mat === 'brs' ? `${Styles.slidetop}` : ``}`} src={main.brs} alt={`Изображение продукции`} />
        </picture>
      </>}
      <p className={`is-size-6 ${Styles.innerslide} ${mat === 'descr' ? `${Styles.slidetop}` : ``}`}>
        {descr}
      </p>
    </div>
  )
}

const ItemView = ({ data, ...props }) => {
  const heightTrick = `0.75rem`;
  const [material, setMaterial] = React.useState('slvr');
  return (<>
    <div className={`is-hidden-touch`} style={{ minHeight: heightTrick, height: heightTrick, maxHeight: heightTrick }}></div>
    <div className={`columns is-align-items-stretch`}>
      <div className={`column is-clipped is-flex is-flex-direction-column is-size-1`}>
        <h1 className={`is-size-3 mainheader is-hidden-desktop`}>{props.header}</h1>
        <Slider nocontrols={(material === 'descr')}>
          <ImageSlide
            key={1}
            descr={props.maintext}
            main={{ slvr: data.slide1.publicURL, brs: data.slide11.publicURL }}
            alt={{ slvr: data.slide1mob.publicURL, brs: data.slide11mob.publicURL }}
            mat={material} />
          <ImageSlide
            key={2}
            descr={props.maintext}
            main={{ slvr: data.slide2.publicURL, brs: data.slide22.publicURL }}
            alt={{ slvr: data.slide2mob.publicURL, brs: data.slide22mob.publicURL }}
            mat={material} />
          <ImageSlide
            key={3}
            descr={props.maintext}
            main={{ slvr: data.slide3.publicURL, brs: data.slide33.publicURL }}
            alt={{ slvr: data.slide3mob.publicURL, brs: data.slide33mob.publicURL }}
            mat={material} />
          <ImageSlide
            key={4}
            descr={props.maintext}
            main={{ slvr: data.slide6.publicURL, brs: data.slide6.publicURL }}
            alt={{ slvr: data.slide6mob.publicURL, brs: data.slide6mob.publicURL }}
            mat={material} />
          <ImageSlide
            key={5}
            descr={props.maintext}
            main={{ slvr: data.slide4.publicURL, brs: data.slide44.publicURL }}
            alt={{ slvr: data.slide4mob.publicURL, brs: data.slide44mob.publicURL }}
            mat={material} />
          <ImageSlide
            key={6}
            descr={props.maintext}
            main={{ slvr: data.slide5.publicURL, brs: data.slide55.publicURL }}
            alt={{ slvr: data.slide5mob.publicURL, brs: data.slide55mob.publicURL }}
            mat={material} />
          <ImageSlide
            key={7}
            descr={props.maintext}
            main={{ slvr: data.video1.publicURL, brs: data.video2.publicURL }}
            alt={{ slvr: data.poster1.publicURL, brs: data.poster2.publicURL }}
            mat={material}
            playable={`true`} />
        </Slider>
      </div>
      <div className={`column is-clipped is-flex is-flex-direction-column`}>
        <div className={`${Styles.flexauto} is-hidden-touch`}>
          <h1 className={`is-size-1`}>{props.header}</h1>
        </div>
        <div className={`${Styles.flexfill} is-flex-direction-column`}>
          <p className={`pt-6 is-size-5less is-hidden-touch`}>{props.maintext}</p>
          <div className={`columns`}>
            <div className={`is-grouped ${Styles.butgroup} column is-4`}>
              <Button className={`${Styles.halfwidth} is-rounded is-primary is-outlined is-size-6`} style={{ display: `inline-flex` }} active={material === 'slvr'} onClick={() => setMaterial(`slvr`)} aria-label={`Переключить материал на серебро`}>
                Серебро
              </Button>
              <Button className={`${Styles.halfwidth} is-radiusless is-primary is-outlined is-size-6 is-hidden-desktop`} style={{ display: `inline-flex` }} active={material === 'descr'} onClick={() => setMaterial(`descr`)} aria-label={`Переключиться на описание`}>
                Описание
              </Button>
              <Button className={`${Styles.halfwidth} is-rounded is-primary is-outlined is-size-6`} style={{ display: `inline-flex` }} active={material === 'brs'} onClick={() => setMaterial(`brs`)} aria-label={`Переключить материал на латунь`}>
                Латунь
              </Button>
            </div>
          </div>
        </div>
        <div className={`${Styles.flexauto}`}>
          <div className={`columns ${Styles.bottompanel} is-mobile is-justify-content-space-between`}>
            <div className={`column ${Styles.flexauto} is-justify-content-space-between is-flex is-flex-direction-column`}>
              {props.pricetext[`${material}`] ? props.pricetext[`${material}`] : ``}
            </div>
            <div className={`column ${Styles.flexauto} is-justify-content-space-between is-flex is-flex-direction-column text-primary`}>
              <div>&nbsp;</div>
              <Link to={`/magaziny`} className={`${Styles.button} button is-rounded is-primary is-outlined is-medium`}><span className={`is-size-5`}>Приобрести</span></Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>)
}

export default ItemView
